export const LEARNING_INTEREST_GROUPS = [
  { pillar: "Cloud Infrastructure",    options: ["AWS", "GCP", "Azure", "Terraform", "Pulumi", "VPC & Networking"] },
  { pillar: "CI/CD & Automation",      options: ["GitHub Actions", "GitLab CI", "ArgoCD", "GitOps", "Ansible"] },
  { pillar: "Kubernetes & Containers", options: ["Kubernetes", "Docker", "Helm", "Service Mesh (Istio/Linkerd)"] },
  { pillar: "Observability",           options: ["Prometheus", "Grafana", "ELK / Loki", "Datadog", "OpenTelemetry"] },
  { pillar: "Cost Optimization",       options: ["FinOps", "Right-sizing", "Reserved / Spot", "Cost dashboards"] },
  { pillar: "Security & Compliance",   options: ["IAM", "Vault / Secrets", "Network Policies", "SOC2", "Image scanning"] },
];
// Flat allowlist derived for display; NOT used server-side (see validation).
export const LEARNING_INTEREST_OPTIONS = LEARNING_INTEREST_GROUPS.flatMap((g) => g.options);
